import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import {getErrorMessage, isComponentEnabledForUser, isComponentVisibleForUser, getCodeList} from 'utils';
import ToolBar from './ToolBar';
import Typography from "@material-ui/core/Typography";
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import PerfectScrollbar from "react-perfect-scrollbar";
import ExtUserList from "./ExtUserList";
import {fetchAllSubjects} from "../../../redux/actions/subjects";
import {fetchAllBranches} from "../../../redux/actions/branches";
import {fetchAllRoles} from "../../../redux/actions/extroles";
import {fetchAllUsers, createUser, updateUser, updateUserState, synchUser} from "../../../redux/actions/extusers";
import {fetchAllCodeList} from "../../../redux/actions/codes"
import {Grid} from '@material-ui/core';
import {ToggleButton} from '@material-ui/lab';
import TocIcon from '@material-ui/icons/Toc';
import ExtUser from 'components/modals/ExtUserUpdate';


const useStyles = makeStyles((theme) => ({
    breadcrumb: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 300,
        color: theme.palette.base[500],
    },
    title: {
        marginBottom: theme.spacing(3.75),
        marginTop: theme.spacing(3.75),
        textTransform: 'uppercase',
    },
    separator: {
        marginLeft: theme.spacing(1.5),
        marginRight: theme.spacing(1.5),
    },
    activeLink: {
        color: theme.palette.secondary.main,
    },
    navLink: {
        cursor: 'pointer',
    },
    container: {
        background: theme.palette.base.white,
        marginTop: theme.spacing(4),
    },
}));


function ExtUserAdministration(props) {
    const {
        userUseCases,
        subjects,
        branches,
        roles,
        users,
        parkings,
        createUser,
        updateUser,
        updateUserState,
        fetchAllRoles,
        fetchAllUsers,
        fetchAllSubjects,
        fetchAllBranches,
        isFetchingAllList,
        user,
        allCodeList,
        fetchAllCodeList,
        synchUser
    } = props;


    const classes = useStyles();
    const {t} = useTranslation();

    const [isFetchedRole, setIsFetchedRole] = useState(false);
    const [isFetchedUser, setIsFetchedUser] = useState(false);
    const [isFetchedSubject, setIsFetchedSubject] = useState(false);
    const [isFetchedBranch, setIsFetchedBranch] = useState(false);
    const [isFetchingAllCodeList, setIsFetchingAllCodeList] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [saving, setSaving] = useState(false);
    const [headerChecked, setHeaderChecked] = useState(0);
    const [tableUpdateData, setTableUpdateData] = useState();
    const [userConfigModel, setUserConfigModel] = useState({
        open: false,
        user: {},
        isNew: true
    });

    useEffect(() => {
        if (!isFetchedRole) {
            setIsLoading(true);
            fetchAllRoles().then(()=>{
                setIsFetchedRole(true)         
            }).catch((err) => {
                console.log(err);
                setIsFetchedRole(false);
            });
        }

        if (!isFetchedUser) {
            fetchAllUsers().then(()=>{
                setIsFetchedUser(true)
            }).catch((err) => {
                console.log(err);
                setIsFetchedUser(false);
            });
        }

        if ( !isFetchedSubject ) {
            fetchAllSubjects().then(()=>{
                setIsFetchedSubject(true)
            }).catch((err) => {
                console.log(err);
                setIsFetchedSubject(false);
            });
        }

        if ( !isFetchedBranch ) {
            fetchAllBranches().then(()=>{
                setIsFetchedBranch(true);
            }).catch((err) => {
                console.log(err);
                setIsFetchedSubject(false);
            });
        }

        if ( !isFetchingAllCodeList ) {
            fetchAllCodeList().then(()=>{
                setIsFetchingAllCodeList(true);
            }).catch((err) => {
                console.log(err);
                setIsFetchingAllCodeList(false);
            });
        }
        setIsLoading(false)

    }, [fetchAllUsers, isFetchedUser, fetchAllRoles, isFetchedRole, fetchAllSubjects, isFetchedSubject, fetchAllCodeList, isFetchingAllCodeList]);


    const [selectedName, setSelectedName] = useState('');
    const [selectedUCName, setSelectedUCName] = useState('');

    const [selectedStatus, setSelectedStatus] = useState();
    const [selectedRole, setSelectedRole] = useState();
    const [selectedSubject, setSelectedSubject] = useState();

    const [table, setTable] = useState(false);

    const handleSelectedName = (value) => {
        setSelectedName(value.target.value);
    };
    const handleSelectedUCName = (value) => {
        setSelectedUCName(value.target.value);

    };
    const handleSelectedStatus = (value) => {
        setSelectedStatus(value);
    };
    const handleSelectedRole = (value) => {
        setSelectedRole(value);
    };
    const handleSelectedSubject = (value) => {
        setSelectedSubject(value);
    };

    const matchStatus = (user) => {
        let res = false;
        for (let i = 0; i < selectedStatus.length; i++) {
            res = ( selectedStatus[i].key === 'ACTIVE' && user.active===true ) || ( selectedStatus[i].key === 'INACTIVE' && user.active===false );
            if (res) {
                return true;
            }
        }
        return false;
    }

    const matchSubject = (user) => {
        for (let i = 0; i < selectedSubject.length; i++) {
            if ( user.subjectId == selectedSubject[i].key )
                return true;
        }
        return false;
    }

    const matchRole = (user) => {
        for (let i = 0; i < selectedRole.length; i++) {
            for ( let j = 0; j < user.roles.length; j++) {
                if ( user.roles[j].roleExtId == selectedRole[i].key )
                    return true;
            }
        }
        return false;
    }

    const matchUC = (user) => {
        for (let i = 0; i < selectedUCName.length; i++) {
            for ( let j = 0; j < user.roles.length; j++) {
                for ( let k = 0; k < user.roles[j].useCases.length; k++) {
                    if ( user.roles[j].useCases[k].code.includes(selectedUCName) || user.roles[j].useCases[k].description.includes(selectedUCName))
                        return true;
                }
            }
        }
        return false;
    }

    useEffect(() => {
        const filUser = [];
        if ( users ) {

            for (let i = 0; i < users.length; i++) {
                let matchCriteria = true;
                if (selectedName && selectedName.trim().length > 0) {
                    if ( !users[i].userName || !users[i].userName.toLowerCase().includes(selectedName.toLocaleLowerCase())) {
                        matchCriteria = false;
                    }
                }

                if (selectedUCName && selectedUCName.trim().length > 0) {
                    const res = matchUC(users[i]);
                    if (!res) {
                        matchCriteria = false;
                    }                   
                }

                if (selectedStatus && selectedStatus.length > 0) {
                    const res = matchStatus(users[i]);
                    if (!res) {
                        matchCriteria = false;
                    }
                }

                if (selectedRole && selectedRole.length > 0) {
                    const res = matchRole(users[i]);
                    if (!res) {
                        matchCriteria = false;
                    }
                }

                if (selectedSubject && selectedSubject.length > 0) {
                    const res = matchSubject(users[i]);
                    if (!res) {
                        matchCriteria = false;
                    }
                }

                if (matchCriteria) {
                    filUser.push(users[i]);
                }
            }
        }
        setFilteredUser(filUser);
    }, [users, selectedName, selectedUCName, selectedStatus, selectedRole, selectedSubject]);


    const [filteredUser, setFilteredUser] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [error, setError] = useState('');

    const [rolesValues, setRolesValues] = useState();
    const [codeList, setCodeList] = useState();
    const [confirmModalOpened, setConfirmModalOpened] = useState(false);

    const [errorSynch, setErrorSynch] = useState('');
    const [doneSynch, setDoneSynch] = useState('');

    useEffect(() => {
        if ( roles) {
            setRolesValues(roles.map(a => {
                return {value: a.roleExtId, label: a.name, key: a.roleExtId}
            }));

            let newData = roles.map((row)=>{
                return {... row, checked:0}
            });
    
            setTableUpdateData(newData);
        }
    }, [roles]);

    const [subjectValues, setSubjectValues] = useState();

    useEffect(() => {
        if (subjects) {
            setSubjectValues(subjects.map(a => {
                return {value: a.subjectId, label: a.name, key: a.subjectId}
            }));
        }
    }, [subjects]);

    useEffect(() => {
        if ( allCodeList )
            setCodeList(getCodeList(allCodeList, 'DS_ROLE'));
    }, [allCodeList])

    const closeUserDetail = () => {
        setError('');
        setSnackbarOpen(false);
        setUserConfigModel({isNew: false, user: {}, open: false, readOnly: false});
        setErrorSynch('');
        setDoneSynch('');
    }

    const handleUserUpdate = (updatedUser, isNew, readOnly) => {
        // parking ID of user

        let user = {...updatedUser}
        if ( user.parkingIds ) {
            let tmp=[];
            for ( let i=0; i<user.parkingIds.split(',').length; i++) {
                for ( let j=0; j<parkings.length; j++) {
                    if ( parkings[j].gmtpIdent==user.parkingIds.split(',')[i] ) {
                        tmp.push(parkings[j]);
                        break;
                    }
                }
            }
            user.parkings=tmp;
        }

        // set checked 
        if ( user && user.roles && roles ) {
            let tmp = [];
            
            if ( readOnly ) {
                for ( let j=0; j<user.roles.length; j++) {
                    roles.map((row) => {
                        if ( row.roleExtId === user.roles[j].roleExtId ) {
                            let ee = {... row};
                            tmp.push(ee);
                        }
                    });
                }
            } else {
                tmp = roles.map((row) => {
                    return {... row, checked:false};
                })
                for (let i=0; i<tmp.length; i++) {
                    for ( let j=0; j<user.roles.length; j++) {
                        if ( tmp[i].roleExtId === user.roles[j].roleExtId ) {
                            tmp[i].checked = 1;
                        }
                    }
                }
            }
            
            setTableUpdateData(tmp);
        } else if (  user && roles ) {
            let tmp = roles.map((row) => {
                return {... row, checked:false};
            })
            setTableUpdateData(tmp);
        }

        user.active=user.active===true?'true':(user.active===false?'false':'');

        setError('');
        setSnackbarOpen(false);
        setUserConfigModel({isNew, user: user, open: true, readOnly: readOnly});
    };
   
    const rowClickHandel = (rowData) => {
        let newData = tableUpdateData.map((row)=>{
            return {... row}
        });

        for (let i=0; i<newData.length; i++) {
            if ( newData[i].name===rowData.name ) {
                if ( !newData[i].checked || newData[i].checked===0)
                    newData[i].checked=1;
                else
                    newData[i].checked=0;
            }
        }

        setTableUpdateData(newData);
    }

    const headerClickHandel = () => {
        let valueChecked=0;
        if ( headerChecked || headerChecked===0 ) {
            if (headerChecked===1) 
                valueChecked=0;
            else 
                valueChecked=1;
        } 

        let newData = tableUpdateData.map((row)=>{
            return {... row}
        });

        for (let i=0; i<newData.length; i++) {
            newData[i].checked=valueChecked;
        }

        setTableUpdateData(newData);
        setHeaderChecked(valueChecked);
    }

    const handleActivate = (user) => {
        updateUserState(user.userExtId, !user.active).then(()=>{
            setConfirmModalOpened(false);
            setIsFetchedUser(false);
        }).catch((err) => {
            console.log(err);
            setIsFetchedUser(false);
        });
    }

    const saveUser = (user) => {

        if ( user && user.active === 'YES') user.active=true;
        if ( user && user.active === 'NO') user.active=false;
        
        if ( tableUpdateData ) {
            user.roles=[];
            
            tableUpdateData.map((item) => {
                if ( item.checked===1 )
                    user.roles.push(item)
            });
        }

        if ( user && user.roles) {
            user.roles.map((item) => {
                item.useCases = [];
            })
        }

        // user = {...user, parkingIds: user.parkingIds, subjectId: user.subjectId}

        const action = (user && user.userExtId ) ? updateUser : createUser;
        action(user).then((prod) => {
            setIsLoading(true);
            setIsFetchedUser(false);
            setSaving(false);
            closeUserDetail();
        }).catch((error) => {
            setIsLoading(false);
            setSaving(false);
            setError(getErrorMessage(error, t));
            setSnackbarOpen(true);
        });
    };

    const synchUserInner = (parkingIds, user) => {
        console.log('synchUserInner', parkingIds, user);
        synchUser(user, parkingIds).then((prod) => {
            setDoneSynch(new String(parkingIds));
            console.log('synchUser done');
        }).catch((error) => {
            console.log('synchUser error');
            setErrorSynch(new String(parkingIds));
        });

    }


    return (
        <PerfectScrollbar
            options={{
                suppressScrollX: true,
                minScrollbarLength: 50,
            }}
        >

            <div className={classes.breadcrumb}>
                {isComponentVisibleForUser(UC_EXT_USER_ADMINISTRATION, userUseCases) &&

                    <Link style={{textDecoration: 'none'}}
                          to={isComponentEnabledForUser(UC_EXT_USER_ADMINISTRATION, userUseCases) ? `/${process.env.REACT_APP_PATH}/administration` : "#"}>

                        <Typography variant="button" className={classnames(classes.activeLink, classes.navLink)}>
                            {t('ADMINISTRATION')}
                        </Typography>
                    </Link>
                }
            </div>

            <Typography variant="h4" className={classes.title}>
                {t('EXT_USER_ADMINISTRATION')}
            </Typography>


            <div className={classes.container}>

                <ToolBar
                    userUseCases={userUseCases}
                    handleUserUpdate={handleUserUpdate}

                    selectedName={selectedName}
                    handleSelectedName={handleSelectedName}
                    selectedUCName={selectedUCName}
                    handleSelectedUCName={handleSelectedUCName}
                    selectedStatus={selectedStatus}
                    handleSelectedStatus={handleSelectedStatus}
                    selectedRole={selectedRole}
                    handleSelectedRole={handleSelectedRole}
                    selectedSubject={selectedSubject}
                    handleSelectedSubject={handleSelectedSubject}

                    roles={rolesValues}
                    subjects={subjectValues}
                />
                <Grid container>
                    <Grid item sm={11}>
                    </Grid>
                    <Grid item sm={1}>
                        <ToggleButton
                            style={{width: '30px', height: '30px'}}
                            value="check"
                            selected={table}
                            onChange={() => {
                                setTable(!table);
                            }}
                        >
                            <TocIcon/>
                        </ToggleButton>
                    </Grid>
                </Grid>
                <ExtUserList
                    refresh={() => {
                        setIsFetchedUser(false);
                    }}
                    table={table}
                    save={saveUser}
                    userUseCases={userUseCases}
                    user={filteredUser}
                    handleUserDetail={handleUserUpdate}
                    isLoading={isFetchingAllList}
                    setSnackbarOpen={setSnackbarOpen}
                    setSnackbarError={error}
                    handleActivate={handleActivate}
                    confirmModalOpened={confirmModalOpened}
                    setConfirmModalOpened={setConfirmModalOpened}
                />

            </div>


            <ExtUser 
                userConfigModel={userConfigModel}
                userUseCases={userUseCases}
                roles={tableUpdateData}
                saveUser={saveUser}
                error={error}
                snackbarOpen={snackbarOpen}
                handleClose={closeUserDetail}
                setSnackbarOpen={setSnackbarOpen}
                setSnackbarError={error}
                subjects={subjects}
                branches={branches}
                hasCertificate={false}
                parkings={parkings}
                codeList={codeList}
                rowClickHandel={rowClickHandel}
                headerClickHandel={headerClickHandel}
                headerChecked={headerChecked}
                saving={saving}
                setSaving={setSaving}
                synchUser={synchUserInner}
                errorSynch={errorSynch}
                doneSynch={doneSynch}
            />


        </PerfectScrollbar>
    );
}

ExtUserAdministration.propTypes = {
    allCodeList: PropTypes.array.isRequired,
};

const UC_EXT_USER_ADMINISTRATION = 'UC0693';

const mapStateToProps = (store) => ({
    user: store.authData.user,
    roles: store.extRolesData.roles,
    users: store.extUsersData.parkingUsers,
    subjects: store.subjectsData.subjects,
    branches: store.branchesData.branches,
    parkings: store.parkingsData.parkings,
    isFetchingAllList: store.extUsersData.isFetchingParkingList,
    allCodeList: store.codesData.allCodeList,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAllRoles,
    fetchAllSubjects,
    fetchAllBranches,
    fetchAllUsers, createUser, updateUser, updateUserState, synchUser,
    fetchAllCodeList,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ExtUserAdministration);
